//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { gmapApi } from 'vue2-google-maps'
var src = '@/assets/cta.kml';


const stringOptions = ([
      { text: 'BASALA', value: 'BASALA' }, { text: 'BENUA', value: 'BENUA' }, { text: 'BUKE', value: 'BUKE' }, { text: 'KONDA', value: 'KONDA' }, { text: 'LAEYA', value: 'LAEYA' }, { text: 'LALEMBUU', value: 'LALEMBUU' }, { text: 'LANDONO', value: 'LANDONO' }, { text: 'PALANGGA', value: 'PALANGGA' },   { text: 'MOWILA', value: 'MOWILA' },
      { text: 'KOLONO TIMUR', value: 'KOLONO TIMUR' },
      { text: 'SABULAKOA', value: 'SABULAKOA' },
      { text: 'ANDOOLO BARAT', value: 'ANDOOLO BARAT' },
      { text: 'ANDOOLO', value: 'ANDOOLO' },
      { text: 'ANGATA', value: 'ANGATA' },
      { text: 'BAITO', value: 'BAITO' },
      { text: 'PALANGGA SELATAN', value: 'PALANGGA SELATAN' },
      { text: 'RANOMEETO', value: 'RANOMEETO' },
      { text: 'RANOMEETO BARAT', value: 'RANOMEETO BARAT' },
      { text: 'WOLASI', value: 'WOLASI' },
      { text: 'KOLONO', value: 'KOLONO' },
      { text: 'LAINEA', value: 'LAINEA' },
      { text: 'LAONTI', value: 'LAONTI' },
      { text: 'MORAMO', value: 'MORAMO' },
      { text: 'MORAMO UTARA', value: 'MORAMO UTARA' },
      { text: 'TINANGGEA', value: 'TINANGGEA' },
      
    ])

export default {
  components: {

  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      alert: false,
      simpan1: false,
      kecamatan :'',
      url : {
        GET_URL : this.$store.state.url.URL_APP + "api/v1/web_home/",

      },
      date : '',

      options: stringOptions,
      list_data : [],
      jumlah_zona : null,
      jumlah_titik : null,


      clusterOptions: {
            gridSize: 30,
            maxZoom: 15,
        },
              
        ///////////////////////TITIK/////////////////////////////////

        polygons_titik: [],
            
            polygonTitikOptions: {
              fillColor: 'blue',
              fillOpacity: 0.5,
              // Opsi warna dan kecerahan arsiran polygon
            },

            markers_titik: [] ,
          

          markerIcon: {
              url: 'img/a.png',
              scaledSize: { width: 40, height: 40 },
            },

          
            ///////////////////////////END TITIK///////////////////////////// 
    }
  },
  methods: {
    mapping: function(data) {

      var tampung = [];
      // console.log(data.length);

      for(var i = 0; i < data.length; i++) {
          var obj = data[i];
          tampung.push({"lat":parseFloat(obj[1]),"lng":parseFloat(obj[0])});
      }

      // console.log(tampung);
      return tampung;

    },
    cari_data: function() {
        
      this.polygons_titik = [];
      this.getViewTitik();
      
    },

    getZona: function() {
        fetch(this.url.GET_URL + "zona", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
           
          })
          .then(res => res.json())
          .then(res_data => {
  
            
            this.jumlah_zona = res_data[0]
            
            // 
  
  
          });
      },
    getTitik: function() {
        fetch(this.url.GET_URL + "titik", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
           
          })
          .then(res => res.json())
          .then(res_data => {
  
            
            this.jumlah_titik = res_data[0]
            
            // 
  
  
          });
      },


    getViewTitik: function() {
          this.cek_load_data = true;


          fetch(this.url.GET_URL + "viewTitik", {
              method: "POST",
              headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                cari_value: this.kecamatan
              })
            })
            .then(res => res.json())
            .then(res_data => {
    
              
              this.viewTitik = res_data;
             
              this.cek_load_data = false;
              

                //////////////CONVERT TO FLOAT AND PUSH TO ARRAY///////////////

                for (let i = 0; i < this.viewTitik.length; i++) {
                    const floatArray = res_data[i].lokasi.map(obj => {
                        return {
                            lat: parseFloat(obj.lat),
                            lng: parseFloat(obj.lng),
                        };
                    });
                   
                    let obj = {
                        paths : floatArray
                    };

                    this.polygons_titik.push(obj);
                }

                //////////////CONVERT TO FLOAT AND PUSH TO MARKERS///////////////

                this.markers_titik = res_data;

                // console.log(this.markers_titik);



              // 
    
    
            });
        },


    simulateProgress (number) {
      // we set loading state
      this[`simpan${number}`] = true
      // simulate a delay
      setTimeout(() => {
        // we're done, we reset loading state
        this[`simpan${number}`] = false
      }, 3000)
    },

    async button(){
      await setTimeout(() => {
        console.log('button')
      }, 2000);
    }

  },

  computed: {
    google: gmapApi
},
  mounted () {
    this.getViewTitik();
    this.getZona();
    this.getTitik();
  },
}
